const defaultGermanLocalizationKeyValues = {
    aumico_reports_annualreport_dialog_create_new_company_title: 'erstelle eine neue Unternehmen',

    aumico_reports_annualreport_page_financial_statement_import_label_upload_balance_sheet: 'Saldobilanz Hochladen',

    aumico_reports_annualreport_page_financial_statement_import_label_account_mapping: 'Kontoplan',

    aumico_reports_annualreport_page_financial_statement_general_information_label_general_information:
        'Allgemeine Informationen',

    aumico_reports_annualreport_page_financial_statement_import_balance_label_import_balance_sheet:
        'Saldobilanz Importieren',
};

// Create a new object for defaultLocalizationKeyValues
const defaultLocalizationKeyValues = {
    // general
    aumico_button_save: 'Save',
    aumico_reports_action_bar_footer_proceed_to: 'Proceed to',
    aumico_reports_action_bar_footer_back_to: 'Back zu',

    // welcome page footer
    aumico_reports_welcome_page_footer_about: 'About',
    aumico_reports_welcome_page_footer_privacy_policy: 'Privacy Policy',
    aumico_reports_welcome_page_footer_imprint: 'Imprint',
    aumico_reports_welcome_page_footer_about_link: 'https://aumico.io/agb/',
    aumico_reports_welcome_page_footer_privacy_policy_link: 'https://aumico.io/datenschutz/',
    aumico_reports_welcome_page_footer_impressum_link: 'https://aumico.io/impressum/',

    // app intro
    aumico_reports_intro_side_text: 'Close to reaching your flow.',
    aumico_reports_login_introduction:
        'Short introduction about benefits working with aumico donec turpis massa, facilisis nec mi quis, cursus convallis justo. Duis metus erat, ornare quis nulla id, porttitor viverra sapien. Aliquam non orci non ante pretium feugiat. ',
    aumico_reports_signup_title: 'Create new account',
    aumico_reports_invitation_intro: "you've ben invited by {inviterName}",
    // login
    aumico_reports_login_title: 'Login',
    aumico_reports_password: 'Password',
    aumico_reports_login_credentials_error: 'Username or password is wrong!',
    aumico_reports_login_forgot_password: 'Forgot password',
    aumico_reports_login_bottom_button_of_question_register: 'Register now',
    aumico_reports_login_bottom_question: "You don't have an account yet?",
    aumico_reports_login_login_button: 'Login',
    aumico_reports_login_credentials_toomany_requests_error:
        'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.',
    aumico_reports_login_credentials_network_request_failed: 'Network failure',
    // forgot password
    aumico_reports_reset_password_forgot_password_title: 'Forgot password?',
    aumico_reports_reset_password_introduction:
        'What we will do when you initiate the process donec turpis massa, facilisis nec mi quis, cursus convallis justo. Duis metus erat, ornare quis nulla id, porttitor viverra sapien. Aliquam non orci non ante pretium feugiat. ',
    aumico_reports_reset_password_forgot_email_username: 'E-Mail / Username',
    aumico_reports_reset_password_credentials_error: 'Username or email is wrong!',

    // confirm account
    aumico_reports_registration_confirmation_title: 'Please confirm your e-mail address',
    aumico_reports_registration_confirmation_introduction:
        'Short introduction and instructions donec turpis massa, facilisis nec mi quis, cursus convallis justo. Duis metus erat, ornare quis nulla id, porttitor viverra sapien. Aliquam non orci non ante pretium feugiat. ',
    aumico_reports_registration_confirmation_bottom_question: 'Did not get an e-mail?',
    aumico_reports_registration_confirmation_bottom_question_button: 'Resend E-Mail',

    // signup
    aumico_reports_registration_bottom_question: 'Do you remember your account?',
    aumico_reports_registration_bottom_button_of_question_login: 'Login now',

    // general errors
    aumico_errors_server_error: 'Server Error',
    aumico_reports_page_not_found: 'Page Not Found',

    // general
    aumico_reports_write_permission_error: "Sorry you don't have write permission.",
    aumico_reports_placeholder_needs_implementation: 'aumico_reports_placeholder_needs_implementation',
    aumico_button_cancel: 'Cancel',
    aumico_button_confirm: 'Confirm',
    aumico_reports_input_please_enter_placeholder: 'Please enter',
    aumico_reports_template_not_found: 'There is no template found with the selected legal form and account basis',
    aumico_reports_required_data_not_completed: 'The data from the previous steps is no completed yet!',
    aumico_reports_page_is_not_part_of_ar_navigation:
        'This route is not part of the annual report navigation for the selected AR template',
    //upload sheet step
    aumico_reports_internal_mapping_changes_warning:
        'The system made some mapping changes so please save if you want to keep them',

    //general information
    aumico_reports_no_annualreport_template_defined:
        'There is no annual report template defined for the selected legal form and accounting basis and specified country',
    aumico_reports_ar_templates_list_dialog_title: 'Annual Report Templates',
    aumico_reports_ar_templates_list_dialog_save_button: 'Save Chosen Annual Report Template',

    // TODO: a previously unfinished work
    introListItem_process: 'about process ',
    introListItem_flow: 'about flow ',
    introListItem_dummy: 'about dummy',

    // navigation
    aumico_reports_main_navigation_financialstatements: 'Financial Statements',
    aumico_reports_main_navigation_company_list: 'Companies',
    aumico_reports_main_navigation_edit_company: 'Edit Company',
    aumico_reports_main_navigation_logout: 'Logout',
    aumico_reports_main_navigation_organization: 'Organization',
    aumico_reports_main_navigation_organization_settings: 'Organization Settings',
    aumico_reports_main_navigation_design_settings: 'Design Settings',
    aumico_reports_organization_settings_navigation_organization_profile: 'Profile',
    aumico_reports_organization_settings_navigation_text_snippets: 'Predefined Text Snippets',
    aumico_reports_organization_navigation_users: ' Users',
    aumico_reports_organization_settings_text_snippets_title: 'Predefined Text Snippets',
    aumico_reports_organization_settings_text_snippets_add_new_button: 'Add new',

    aumico_reports_organization_settings_text_snippets_form_dialog_create_success_notification_description:
        'Text snippet created successfully',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_conflict_error_notification_description:
        'Error in create text snippet: description already exists',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_internal_server_error_description:
        'Error in create text snippet: Internal server error',
    aumico_reports_organization_settings_text_snippets_form_dialog_error_notification_title: 'Error',
    aumico_reports_organization_settings_text_snippets_form_dialog_success_notification_title: 'Success',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Add new text snippet',
    aumico_reports_organization_settings_text_snippets_update_dialog_title: 'Update text snippet',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_success_notification_description:
        'Text snippet updated successfully',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_error_notification_description:
        'Failed to update text snippet: internal server error',

    aumico_reports_profile_navigation_generalinformation: 'General Information',
    aumico_reports_profile_navigation_security: 'Security',
    aumico_reports_annualreport_navigation_generalinformation: 'General Information',
    aumico_reports_annualreport_navigation_import: 'Import Balance Sheet',
    aumico_reports_annualreport_navigation_fcp: 'Fincancial Closing Process',
    aumico_reports_annualreport_navigation_import_upload: 'Upload Balance Sheet',
    aumico_reports_annualreport_navigation_import_mapping: 'Account Mapping',
    aumico_reports_annualreport_navigation_import_grouping_masking: 'Grouping / Masking',
    aumico_reports_annualreport_navigation_notes_and_aop: 'Notes & Appropriation of Profit',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Equity Movement',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Fixed Assets',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Adjustments & Reclasses',
    aumico_reports_annualreport_navigation_complementary_reports: 'Complementary Reports',
    aumico_reports_annualreport_navigation_finish_and_print: 'aumico_reports_annualreport_navigation_finish_and_print',
    aumico_reports_annualreport_navigation_reorder_report_and_print: 'Print in different structure',
    aumico_reports_annualreport_navigation_print_using_pdf_tron: 'Print using Pdf Tron',
    aumico_reports_annualreport_navigation_share_annual_report: 'Secure Share Report',
    aumico_reports_annualreport_navigation_cfs: 'Cash Flow Statement',
    aumico_reports_annualreport_navigation_notes: 'Notes',
    aumico_reports_annualreport_navigation_aop: 'Appropriation of profits',

    aumico_annual_report_import_page_can_not_navigate_to_mapping_dialog_description:
        'You have to upload data first to navigate to mapping step',

    aumico_reports_annualreport_cover_annual_label_title_1st_prefix: 'Annual financial statement',
    aumico_reports_annualreport_cover_label_title_2nd_prefix: 'for the period',
    aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix: 'Quarterly financial statement',
    aumico_reports_annualreport_cover_monthly_label_title_1st_prefix: 'Monthly financial statement',
    aumico_reports_annualreport_cover_custom_label_title_1st_prefix: 'Financial statement',
    aumico_reports_annualreport_toc_label_table_of_contents: 'Table of contents',
    aumico_reports_annualreport_print_date_from: 'from',
    aumico_reports_annualreport_print_date_to: 'to',
    aumico_reports_annualreport_print_date_of: 'as of',
    aumico_reports_annualreport_print_label_previous_year: 'Previous year',
    aumico_reports_annualreport_print_label_current_year: 'Current year',
    aumico_reports_annualreport_print_label_ratio: 'Ratio',
    aumico_reports_annualreport_print_label_taxdomicile: 'Tax domicile',
    aumico_reports_annualreport_print_label_taxid: 'Tax id',
    aumico_reports_annualreport_print_label_assets: 'ASSETS',
    aumico_reports_annualreport_print_label_liabilities: 'LIABILITIES',
    aumico_reports_annualreport_print_label_page: 'page',

    aumico_annual_report_general_information_create_new_company_btn_text: 'Create new company',

    aumico_reports_annualreport_page_print_account_mapping_label_notes: 'Notes',
    aumico_reports_annualreport_page_adjustments_label_account_number: 'Account Number',

    aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency: 'in',
    aumico_reports_annualreport_page_print_account_mapping_label_total: 'Total',

    aumico_reports_annualreport_navigation_label_balance: 'Balance',
    aumico_reports_annualreport_navigation_label_income: 'Income',
    // FS overview
    aumico_reports_share_annual_report_dialog_title: 'Share Your Report',
    aumico_reports_share_annual_report_dialog_content: 'Select & invite users',
    aumico_reports_share_annual_report_dialog_input_label: 'Share with users via E-Mail address',
    aumico_reports_share_annual_report_dialog_input_placeholder: 'Please enter Email',
    aumico_reports_share_annual_report_dialog_save_button: 'Share Report',
    aumico_reports_share_annual_report_confirmation_dialog_save_button: 'Yes, Share',
    aumico_reports_share_annual_report_confirmation_go_back_cancel_button: 'go back',
    aumico_reports_share_annual_report_confirmation_dialog_message: 'Are you sure you want to share your report with:',
    // bexio
    aumico_reports_bexio_error:
        'Either you rejected to grant the needed permissions or an error occurred while processing your request',
    // unsaved changes warning dialog
    aumico_reports_unsaved_changes_warning_dialog_content: 'You have unsaved changes. Do you want to save your data?',
    aumico_reports_unsaved_changes_warning_dialog_save: 'Save',
    aumico_reports_unsaved_changes_warning_dialog_discard: 'Discard changes',
    aumico_reports_unsaved_changes_warning_dialog_cancel: 'Cancel',
    aumico_reports_unsaved_changes_warning_dialog_save_unsuccessful: 'Saving is unsuccessful',

    //equity movement schedule
    aumico_reports_equity_movement_schedule_no_table_shown_error_message:
        'No Valid Equity Group Flis are available to show the table',
    aumico_reports_equity_movement_schedule_refresh_button_text: 'Refresh EMS',
    aumico_annual_report_ems_total_equity_header_text: 'Total Equity',

    // Fas
    aumico_report_fas_print_subtotal: 'Subtotal',
    aumico_report_fas_print_section_costs_title: 'Acquisition and Production Costs',
    aumico_report_fas_print_section_depr_title: 'Cumulated Depreciations',
    aumico_report_fas_print_section_valueApr_title: 'Value Appreciations',
    aumico_report_fas_print_section_bookvalue_current: 'Book Value',
    aumico_report_fas_print_section_bookvalue_previous: 'Book Value',
    aumico_report_fas_print_costs_additions: 'Costs Additions',
    aumico_report_fas_print_costs_disposals: 'Costs Disposals',
    aumico_report_fas_print_costs_transfers: 'Costs Transfers',
    aumico_report_fas_print_depreciations_additions: 'Depreciations Additions',
    aumico_report_fas_print_depreciations_disposals: 'Depreciations Disposals',
    aumico_report_fas_print_depreciations_transfers: 'Depreciations Transfers',
    aumico_report_fas_print_value_appreciation: 'Value Appreciation',

    //equality check warning popup
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal:
        'Profit FLI in balance sheet is not equal to profit income in current year.',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal:
        'Profit FLI in balance sheet is not equal to profit income in previous year.',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal:
        'Profit FLI in balance sheet is not equal to profit income in both current and previous years.',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal:
        'Assets is not equal to Liabilities and equity in both current and previous years',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal:
        'Assets is not equal to Liabilities and equity in previous year',
    aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal:
        'Assets is not equal to Liabilities and equity in current year',
    aumico_reports_equality_check_dialog_cashflow_totals_closing_not_equal:
        'Cashflow totals are not equal in the current year.',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_not_equal:
        'Cashflow totals are not equal in the previous year.',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_and_closing_not_equal:
        'Cashflow totals are not equal in both the current previous years.',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_and_closing_not_equal:
        'total reclasses asstes and total reclasses liabilities are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_not_equal:
        'total reclasses asstes and total reclasses liabilities are not equal in the previous year',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_closing_not_equal:
        'total reclasses asstes and total reclasses liabilities are not equal in the current year',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_and_closing_not_equal:
        'total adjustments asstes and total adjustments liabilities are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_not_equal:
        'total adjustments asstes and total adjustments liabilities are not equal in the previous year',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_closing_not_equal:
        'total adjustments asstes and total adjustments liabilities are not equal in the current year',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_and_closing_not_equal:
        'total reclasses income and total reclasses profit fli are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_closing_not_equal:
        'total reclasses income and total reclasses profit fli are not equal in the current year',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_not_equal:
        'total reclasses income and total reclasses profit fli are not equal in the previous year',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_and_closing_not_equal:
        'total adjustments income and total adjustments profit fli are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_closing_not_equal:
        'total adjustments income and total adjustments profit fli are not equal in the current year',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_not_equal:
        'total adjustments income and total adjustments profit fli are not equal in the previous year',
    aumico_reports_equality_check_dialog_proceed: 'Proceed',
    aumico_reports_equality_check_dialog_go_back_and_correct_it: 'Go back and correct it',

    //companies
    aumico_companies_changes_saved_successfully_dialog: 'Saved successfully',

    // print preview
    aumico_annual_report_print_preview_balance: 'Balance',
    aumico_annual_report_print_preview_income: 'Income',
    aumico_annual_report_print_preview_attachement: 'Attachement',
    aumico_annual_report_print_preview_aop: 'Appropriation of profit',
    aumico_annual_report_print_preview_cashflow: 'Cashflow',
    aumico_annual_report_print_preview_ems: 'Equity Movement Schedule',
    aumico_annual_report_print_preview_fas: 'Fixed Assets Schedule',
    aumico_annual_report_print_preview_fcp: 'Financial Closing Process',
    aumico_annual_report_print_preview_account_proof_for_balance: 'Account Proof For Balance',
    aumico_annual_report_print_preview_account_proof_for_income: 'Account Proof For Income',
    aumico_reports_print_page_data_not_available: 'No data available',

    //print
    aumico_reports_print_text_color: 'Text Color',
    aumico_reports_print_highlight_color_1: 'Highlight Color 1',
    aumico_reports_print_highlight_color_2: 'Highlight Color 2',
    aumico_reports_print_title_color: 'Title Color',
    aumico_reports_print_table_header_color: 'Table Header Color',
    aumico_reports_print_table_footer_color: 'Table Fiiter Color',
    aumico_reports_print_page_adjustments_reclasses_warning:
        'Please be aware that manually performed changes in Cash Flow Statement might be overwritten through internal values',
    aumico_reports_warning_popup_warning_title: 'Warning',
    aumico_reports_print_page_fixed_assets_schedule_invalid_warning:
        'Mapping Data is incosistent with saved Fixed Assets Schedule Data. Please go to the FAS table to update it.',
    _: '',
    aumico_reports_print_title_establishment: 'aumico_reports_print_title_establishment',

    aumico_annual_report_proposal_description: 'Proposal for the appropriation of retained earnings.',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Carried forward to new account',
    aumico_annual_report_proposal_available_retained_earnings: 'Available retained earnings',
    aumico_annual_report_profit_calculation_header: 'Proposal for the appropriation of retained earnings',
    aumico_annual_report_cash_flow_total_cashAndCashStart: 'Cash and cash equivalents at beginning of period',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'Cash and cash equivalents at end of period',
    aumico_annual_report_cash_flow_total_total1_name: 'Total Change in Cash',
    aumico_annual_report_cash_flow_total_total2_name: 'Total Change in Cash',
    aumico_annual_report_cash_flow_total_recapitulation: 'Recapitulation',
    aumico_annual_report_ems_row_title: 'Equity as of',
    aumico_annual_report_ems_business_year: 'Financial year',
    aumico_annual_report_profit_calculation_annual_profit: 'Annual Profit',
    aumico_cover_page_internal_label: 'aumico_cover_page_internal_label',

    // reorder report sections
    aumico_reports_reorder_report_sections_dialog_title: 'Reorder Report Sections',
    aumico_reports_reorder_report_cover_section_title: 'Cover',
    aumico_reports_reorder_report_section_save_button: 'Save & Print',

    // Accept shares dialog
    aumico_reports_share_annual_report_dialog_accept_button: 'Accept',
    aumico_reports_share_annual_report_dialog_decline_button: 'Decline',
    aumico_reports_share_annual_report_dialog_text:
        'Wants to share a financial statement. Do you want to accept the share of this organization?',
    //invite new users dialog
    aumico_reports_invite_new_users_dialog_title: 'Invite new organisation user',

    aumico_reports_invite_new_users_dialog_input_label: 'Invite users via E-Mail address',
    aumico_reports_invite_new_users_dialog_input_placeholder: 'Add Email Address',
    aumico_reports_invite_new_users_dialog_save_button: 'Save and Invite',
    aumico_reports_invite_users_success_message: 'Users have been invited successfully',
    aumico_reports_invite_users_wrong_data_error_message: 'Wrong data has been sent',
    aumico_reports_invite_users_email_already_exist_error_message:
        'The following e-mails were not invited because e-mails already exist in another organization',
    aumico_reports_invite_users_cannot_invite_same_organization_users:
        'The following e-mails were not invited because e-mails already exist in this organization',
    aumico_reports_invite_users_failure_okay_button_label: 'Okay',

    // customer attraction dialog
    aumico_reports_customer_attraction_dialog_title: 'Curious about how you can use aumico with your company?',
    aumico_reports_customer_attraction_dialog_descriptive_text:
        'We have some great solutions for Pellentesque sem mi sapien diam sem sed porttitor. Feugiat ultrices molestie varius adipiscing vitae amet tempor amet. Pharetra vulputate sagittis bibendum.',
    aumico_reports_customer_attraction_dialog_button_text: 'Talk to us',
    aumico_reports_customer_attraction_dialog_text_below_button: 'or call us: +12 345 67686',

    //remove users
    aumico_reports_remove_users_user_removing_self_error_message: 'You cannot remove yourself from the users',
    aumico_reports_remove_users_success_message: 'Users have been removed successfully',

    //error dialog
    aumico_reports_error_dialog_something_went_wrong: 'Something went wrong',
    aumico_reports_error_dialog_bad_request: 'Bad request',
    aumico_reports_error_dialog_bad_request_first_and_last_names_required: 'First and last names are required',
    aumico_reports_error_dialog_bad_request_phone_number_invalid:
        'Phone number must be in the right format and must not be empty',
    aumico_reports_error_profit_fli_not_found:
        'The Profit FLI is configured in the balance template but cannot be found. Please check your template configuration.',

    // notification
    aumico_reports_notification_success_title: 'Success',
    aumico_reports_notification_error_title: 'Error',
    aumico_reports_notification_information_title: 'Information',
    aumico_notification_resend_email_success: 'Success',
    aumico_notification_resend_email_failure: 'Failure',
    aumico_notification_resend_email_success_content: 'Email sent Successfully, please check your mail',
    aumico_notification_resend_email_failed_content: 'Failure in sending an email, please try again later',
    aumico_reports_share_annual_report_success_notification_title: 'Shared successfully',
    aumico_reports_share_annual_report_success_notification_description: 'Your Annual Report has Shared Successfully',
    aumico_annual_report_print_only: 'aumico_annual_report_print_only',
    aumico_annual_report_account_proof_display_account_number_column_header: 'Konto',
    aumico_annual_report_account_proof_display_account_name_column_header: 'Bezeichnung',
    aumico_annual_report_display_current_date_column_header: 'Geschäftsperiode',
    aumico_annual_report_display_previous_date_column_header: 'Vorperiode',
    aumico_annual_report_print_preview_appendix_section_title: 'Appendix -de',
    aumico_annual_report_aop_description: 'Appropriation of profit Description',
    // override all by the german values
    ...defaultGermanLocalizationKeyValues,
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key
export const localizationKeys = { ...defaultLocalizationKeyValues, ...defaultGermanLocalizationKeyValues };
